module.exports = __webpack_public_path__ + "5d3aa7ff.svg";